import React, { useMemo } from "react";
import "./FlueGas.css";
import { usePlantStore } from "../engine/usePlantStore";

function StackFlueGas({

  x = 100,
  y = 100,

  width = 200,
  height = 400,

}) {

  /* =====================================
     READ VALUES FROM PLANT STORE
  ===================================== */

  const { transmitters } = usePlantStore();

  const TT_2102 =
    Number(transmitters.TT_2102 ?? 25);

  const Damper_Opening =
    Number(transmitters.Damper_Opening ?? 0);

  /* =====================================
     TEMPERATURE INTENSITY
  ===================================== */

  const temperatureIntensity = useMemo(() => {

    if (TT_2102 < 50)
      return 0;

    return Math.min(
      (TT_2102 - 50) / 450,
      1
    );

  }, [TT_2102]);

  /* =====================================
     DAMPER INTENSITY
  ===================================== */

  const stackDamperFactor = useMemo(() => {

    if (Damper_Opening < 5)
      return 0;

    return Math.min(
      (Damper_Opening - 5) / 95,
      1
    );

  }, [Damper_Opening]);

  /* =====================================
     FINAL FLUE INTENSITY
  ===================================== */

  const flueIntensity =
    temperatureIntensity *
    stackDamperFactor;

  /* =====================================
     PARTICLE COUNT
  ===================================== */

  const particleCount = useMemo(() => {

    if (flueIntensity <= 0)
      return 0;

    return Math.floor(
      5 +
      flueIntensity * 115
    );

  }, [flueIntensity]);

  /* =====================================
     GENERATE PARTICLES ONLY ONCE
  ===================================== */

  const particles = useMemo(() => {

    return [...Array(150)].map(
      (_, i) => ({

        id: i,

        left:
          Math.random() * 100,

        bottom:
          Math.random() * 20,

        size:
          2 +
          Math.random() * 8,

        delay:
          Math.random() * 5,

        duration:
          1.5 +
          Math.random() * 2.5

      })
    );

  }, []);

  /* =====================================
     ABSOLUTE SHUTDOWN
  ===================================== */

  if (particleCount === 0) {
    return null;
  }

  return (

    <div

      className="flue-gas-container"

      style={{

        position: "absolute",

        left: x,
        top: y,

        width,
        height,

        overflow: "hidden",

        pointerEvents: "none",

        zIndex: 500

      }}

    >

      {

        particles
          .slice(0, particleCount)
          .map((particle) => (

            <div

              key={particle.id}

              className="flue-particle"

              style={{

                left:
                  `${particle.left}%`,

                bottom:
                  `${particle.bottom}%`,

                width:
                  `${particle.size}px`,

                height:
                  `${particle.size}px`,

                opacity:
                  0.05 +
                  (
                    flueIntensity *
                    0.75
                  ),

                animationDelay:
                  `${particle.delay}s`,

                animationDuration:
                  `${particle.duration}s`

              }}

            />

          ))

      }

    </div>

  );

}

export default StackFlueGas;